import { Navigate } from "react-router-dom";
import AdminLayout from "../Layout/AdminLayout/AdminLayout";
// ==========Auth Routes==========
import Login from "../Pages/Auth/Login/Login";
import ForgotPassword from "../Pages/Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "../Pages/Auth/ResetPassword/ResetPassword";
// ==========Admin Page Imports (keep these)==========
import Dashboard from "../Pages/Admin/Dashboard/DashboardRedesign";
import AddCustomer from "../Pages/Admin/CustomerManagement/AddCustomer";
import CustomerManagement from "../Pages/Admin/CustomerManagement/CustomerManagement";
import YearlyGraph from "../Pages/Admin/Graph/YearlyGraph/YearlyGraph";
import FundsDeposit from "../Pages/Admin/FundsManagement/FundsDeposit/FundsDeposit";
import TermsAndConditions from "../Pages/Admin/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../Pages/Admin/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "../Pages/Admin/AboutUs/AboutUs";
import PDFReportSettings from "../Pages/Admin/PDFReportSettings/PDFReportSettings";
import PDFReportGenerator from "../Pages/Admin/PDFReportGenerator/PDFReportGenerator";
import ReportLibrary from "../Pages/Admin/ReportLibrary/ReportLibrary";
import ViewCustomer from "../Pages/Admin/CustomerManagement/ViewCustomer";
import CapitalRoutingMonitor from "../Pages/Admin/CustomerManagement/CapitalRouting/CapitalRoutingMonitor";
import WithdrowFunds from "../Pages/Admin/FundsManagement/WithdrowFunds/WithdrowFunds";
import MonthlyGraph from "../Pages/Admin/Graph/MonthlyGraph/MonthlyGraph";
import AddMonthlyGraph from "../Pages/Admin/Graph/MonthlyGraph/AddMonthlyGraph";
import DatabaseAnalysis from "../Pages/Admin/DatabaseAnalysis/DatabaseAnalysis";
import FundAnalytics from "../Pages/Admin/FundAnalytics/FundAnalytics";
import FundRules from "../Pages/Admin/FundRules/FundRules";
import FundControlCenter from "../Pages/Admin/FundControlCenter/FundControlCenter";
import YieldProductManagement from "../Pages/Admin/YieldManagement/YieldProductManagement";
import YieldMonthlyProcessor from "../Pages/Admin/YieldManagement/YieldMonthlyProcessor";
import YieldFinalSubmission from "../Pages/Admin/YieldManagement/YieldFinalSubmission";
import AppVersionSettings from "../Pages/Admin/AppVersionSettings/AppVersionSettings";
import AdminSettings from "../Pages/Admin/AdminSettings/AdminSettings";
import NotificationCenter from "../Pages/Admin/NotificationCenter/NotificationCenter";
import ClientCommunications from "../Pages/Admin/ClientCommunications/ClientCommunications";
import Reminders from "../Pages/Admin/Reminders/Reminders";
import SystemHealth from "../Pages/Admin/SystemHealth/SystemHealth";
import KatuVisits from "../Pages/Admin/KatuVisits/KatuVisits";
import WalletManagement from "../Pages/Admin/WalletManagement/WalletManagement";
import WalletCheck from "../Pages/Admin/WalletCheck/WalletCheck";
import WalletReconciliation from "../Pages/Admin/WalletReconciliation/WalletReconciliation";
import SecurityArchitecture from "../Pages/Admin/SecurityArchitecture/SecurityArchitecture";
import AutoPayFlow from "../Pages/Admin/AutoPayFlow/AutoPayFlow";
import KycControlCenter from "../Pages/Admin/KycControlCenter/KycControlCenter";
// ==========Public Routes (No Authentication Required)==========
import PrivacyPolicyPublic from "../Pages/Public/PrivacyPolicyPublic";
import TermsAndConditionsPublic from "../Pages/Public/TermsAndConditionsPublic";
import YieldTermsPublic from "../Pages/Public/YieldTermsPublic";

// ========== REMOVE SimpleTest Import ==========
// import SimpleTest from '../SimpleTest'; // Remove this line

// ==========Admin Routes==========

const routes = [
  {
    path: "/",
    component: <Navigate to="/login" component={<Login />} />,
    exact: true,
  },
  {
    path: "/login",
    component: <Login />,
    exact: true,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
    exact: true,
  },
  {
    path: "/reset-password",
    component: <ResetPassword />,
    exact: true,
  },
  // ========== PUBLIC ROUTES (No Authentication Required) ==========
  {
    path: "/privacyPolicy",
    component: <PrivacyPolicyPublic />,
    exact: true,
  },
  {
    path: "/termsAndCondition",
    component: <TermsAndConditionsPublic />,
    exact: true,
  },
  {
    path: "/yield-terms",
    component: <YieldTermsPublic />,
    exact: true,
  },
  // ========== RESTORED ROUTE ==========
  // Point /admin/* back to AdminLayout
  {
    path: "/admin/*",
    component: <AdminLayout />, // Changed back from <SimpleTest />
    exact: true,
  },
  // ====================================
];

// Rotas relativas ao pai /admin/* — React Router v6 exige paths relativos em rotas aninhadas
export const adminLayoutRoute = [
  {
    path: "",
    component: <Navigate to="/admin/dashboard" replace />,
    exact: true,
    sidebar: false,
  },
  {
    path: "dashboard",
    component: <Dashboard />,
    exact: true,
    sidebar: true,
  },
  {
    path: "addcustomer",
    component: <AddCustomer />,
    exact: true,
    sidebar: false,
  },
  {
    path: "editcustomer",
    component: <AddCustomer />,
    exact: true,
    sidebar: false,
  },
  {
    path: "viewcustomer",
    component: <ViewCustomer />,
    exact: true,
    sidebar: false,
  },
  {
    path: "capital-routing",
    component: <CapitalRoutingMonitor />,
    exact: true,
    sidebar: false,
  },
  {
    path: "customermanagement",
    component: <CustomerManagement />,
    exact: true,
    sidebar: true,
  },
  {
    path: "monthlygraph",
    component: <MonthlyGraph />,
    exact: true,
    sidebar: true,
  },
  {
    path: "add-monthly-graph",
    component: <AddMonthlyGraph />,
    exact: true,
    sidebar: false,
  },
  {
    path: "yearly-graph",
    component: <YearlyGraph />,
    exact: true,
    sidebar: true,
  },
  {
    path: "fundsdeposit",
    component: <FundsDeposit />,
    exact: true,
    sidebar: true,
  },
  {
    path: "withdrawfunds",
    component: <WithdrowFunds />,
    exact: true,
    sidebar: true,
  },
  {
    path: "wallet-management",
    component: <WalletManagement />,
    exact: true,
    sidebar: true,
  },
  {
    path: "wallet-check",
    component: <WalletCheck />,
    exact: true,
    sidebar: true,
  },
  {
    path: "wallet-reconciliation",
    component: <WalletReconciliation />,
    exact: true,
    sidebar: true,
  },
  {
    path: "kyc-control-center",
    component: <KycControlCenter />,
    exact: true,
    sidebar: true,
  },
  {
    path: "termsandconditions",
    component: <TermsAndConditions />,
    exact: true,
    sidebar: true,
  },
  {
    path: "privacypolicy",
    component: <PrivacyPolicy />,
    exact: true,
    sidebar: true,
  },
  {
    path: "aboutus",
    component: <AboutUs />,
    exact: true,
    sidebar: true,
  },
  {
    path: "pdf-report-settings",
    component: <PDFReportSettings />,
    exact: true,
    sidebar: true,
  },
  {
    path: "pdf-report-generator",
    component: <PDFReportGenerator />,
    exact: true,
    sidebar: true,
  },
  {
    path: "report-library",
    component: <ReportLibrary />,
    exact: true,
    sidebar: true,
  },
  {
    path: "database-analysis",
    component: <DatabaseAnalysis />,
    exact: true,
    sidebar: false,
  },
  {
    path: "fund-analytics",
    component: <FundAnalytics />,
    exact: true,
    sidebar: true,
  },
  {
    path: "fund-control-center",
    component: <FundControlCenter />,
    exact: true,
    sidebar: true,
  },
  {
    path: "fund-rules",
    component: <FundRules />,
    exact: true,
    sidebar: true,
  },
  {
    path: "yield-products",
    component: <YieldProductManagement />,
    exact: true,
    sidebar: true,
  },
  {
    path: "yield-monthly",
    component: <YieldMonthlyProcessor />,
    exact: true,
    sidebar: true,
  },
  {
    path: "yield-final",
    component: <YieldFinalSubmission />,
    exact: true,
    sidebar: true,
  },
  {
    path: "app-version-settings",
    component: <AppVersionSettings />,
    exact: true,
    sidebar: true,
  },
  {
    path: "admin-settings",
    component: <AdminSettings />,
    exact: true,
    sidebar: true,
  },
  {
    path: "notifications",
    component: <NotificationCenter />,
    exact: true,
    sidebar: true,
  },
  {
    path: "client-communications",
    component: <ClientCommunications />,
    exact: true,
    sidebar: true,
  },
  {
    path: "reminders",
    component: <Reminders />,
    exact: true,
    sidebar: true,
  },
  {
    path: "system-health",
    component: <SystemHealth />,
    exact: true,
    sidebar: true,
  },
  {
    path: "katu-visits",
    component: <KatuVisits />,
    exact: true,
    sidebar: true,
  },
  {
    path: "security-architecture",
    component: <SecurityArchitecture />,
    exact: true,
    sidebar: true,
  },
  {
    path: "auto-pay-flow",
    component: <AutoPayFlow />,
    exact: true,
    sidebar: true,
  },
];
export default routes;